// import React from 'react';
// import './Sustainability.css';
// import AllIntroTemplate from "../../components/AllIntroTemplate/AllIntroTemplate.js";

// import ContentModel from "../../components/ContentModel/ContentModel.js";
// import { getStoredData } from "../../json/fetchData.js";

// const Sustainability = () => {
//   const totalData = getStoredData();
//   const data = totalData ? totalData["21"] : {};
//   return (
//     <div>
//       <AllIntroTemplate 
//         image={data.Image} 
//         title={data.Title} 
//         page={totalData ? totalData["0"] : {}}
//       />
//       <ContentModel data={totalData ? totalData["21"] : {}}/>
//     </div>
//   );
// };

// export default Sustainability;


import React, { lazy, Suspense } from 'react';
import './Sustainability.css';
import { getStoredData } from "../../json/fetchData.js"; // Move this import to the top

// Lazy load components
const AllIntroTemplate = lazy(() => import("../../components/AllIntroTemplate/AllIntroTemplate.js"));
const ContentModel = lazy(() => import("../../components/ContentModel/ContentModel.js"));

const Sustainability = () => {
  const totalData = getStoredData();
  const data = totalData ? totalData["21"] : {};

  return (
    <div>
      <Suspense fallback={<p>Loading intro...</p>}>
        <AllIntroTemplate 
          image={data.Image} 
          title={data.Title} 
          page={totalData ? totalData["0"] : {}}
        />
      </Suspense>

      <Suspense fallback={<p>Loading content...</p>}>
        <ContentModel data={totalData ? totalData["21"] : {}} />
      </Suspense>
    </div>
  );
};

export default Sustainability;
